module.exports = __webpack_public_path__ + "static/media/bg-front-cover.e0edc4eb.png";